module.exports = __webpack_public_path__ + "img/pstv.0c5e198d.png";